export default __webpack_public_path__ + "static/media/listView.6ea9460c.svg";